/** Prefijo del precio mínimo de la tarjeta ("Desde 20 €"). */
export const PRICE_FROM_PREFIX = 'Desde'

/** Símbolo de divisa mostrado junto al precio mínimo. */
export const CURRENCY_SYMBOL = '€'

/** Color de fondo cuando el ítem no trae imagen (mismo tono neutro que `Poster`). */
export const POSTER_FALLBACK_COLOR = 'var(--color-gray-20)'
